import { useEffect,useRef  } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import i18n from './i18n';
import { getDomainConfig } from '../config/domainConfig';

export const setCulture = (culture, navigate, location) => {
  const { defaultLanguage, showLanguageSwitcher } = getDomainConfig();
  i18n.changeLanguage(culture);
  localStorage.setItem('culture', culture);

  const urlParams = new URLSearchParams(location.search);

  if (showLanguageSwitcher && culture.toLowerCase() !== defaultLanguage.toLowerCase()) {
    urlParams.set('culture', culture);
  } else {
    urlParams.delete('culture');
  }
  navigate(`${location.pathname}?${urlParams.toString()}`, { replace: true });
};

const useCultureChange = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isInitialLoad = useRef(true); // Track if this is the initial render

  useEffect(() => {
    const { defaultLanguage, showLanguageSwitcher, supportedLanguages } = getDomainConfig();
    const supported = supportedLanguages.map((code) => code.toLowerCase());
    const isSupported = (value) => !!value && supported.includes(value.toLowerCase());

    const urlParams = new URLSearchParams(location.search);
    const rawSessionCulture = localStorage.getItem('culture');
    const rawUrlCulture = urlParams.get('culture');

    const sessionCulture = isSupported(rawSessionCulture) ? rawSessionCulture.toLowerCase() : null;
    const urlCulture = isSupported(rawUrlCulture) ? rawUrlCulture.toLowerCase() : null;

    const culture = urlCulture || sessionCulture || defaultLanguage.toLowerCase();

    if (i18n.language !== culture) {
      i18n.changeLanguage(culture);
    }

    // Store culture in sessionStorage if it’s new or different from the current one
    if (rawSessionCulture !== culture) {
      localStorage.setItem('culture', culture);
    }

    const shouldHaveCultureInUrl =
      showLanguageSwitcher &&
      culture.toLowerCase() !== defaultLanguage.toLowerCase();

    if (rawUrlCulture && !shouldHaveCultureInUrl) {
      urlParams.delete('culture');
      navigate(`${location.pathname}?${urlParams.toString()}`, { replace: true });
    } else if (!isInitialLoad.current && shouldHaveCultureInUrl && !urlCulture) {
      urlParams.set('culture', culture);
      navigate(`${location.pathname}?${urlParams.toString()}`, { replace: true });
    }
    isInitialLoad.current = false;
  }, [location, navigate]);
};

export default useCultureChange;